// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3JXDG","footer":"ModalUpdate_footer__1ltDi"};